module.exports = __webpack_public_path__ + "img/help_authentication_x@3x.e5ba1330.png";